<split-filter-dropdown 
    class="w-full"
    [field]="field" 
    [data]="data" 
    [label]="label"
    [key]="key"
    [groupId]="groupId"
    (onSearchEvent)="onSearchDropdownChange($event)"
    (onFilterEvent)="this.onFilterEvent.emit($event)"
></split-filter-dropdown>
